import api from "@/lib/api";

export default {
    urlGetAll: "/api/v1/financial/cost-center/get-all",
    urlCreate: "/api/v1/financial/cost-center/create",
    urlUpdate: "/api/v1/financial/cost-center/update",
    urlDelete: "/api/v1/financial/cost-center/delete",

    async getAll(params = {}) {
        const response = await api.get(this.urlGetAll, { params });
        return response.data;
    },
    async create(model) {
        const response = await api.post(this.urlCreate, model, { showSuccessToast: true });
        return response.data;
    },
    async update(model) {
        const response = await api.post(this.urlUpdate, model, { showSuccessToast: true });
        return response.data;
    },
    async delete(ids) {
        const response = await api.post(this.urlDelete, { ids });
        return response.data;
    },
};
